// eslint-disable-next-line @typescript-eslint/ban-types
export const objectKeys = <T extends object>(obj: T): (keyof T)[] => {
  // eslint-disable-next-line
  if (obj == null) return [];

  return Object.keys(obj) as (keyof T)[];
};
